import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enUS, es, pt } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@/store';
import { interfaceLanguageSelector } from '@/store/reducers/auth';
import styles from './BimloaFilter.module.scss';
import classes from 'classnames';

type PickerProps = {
  date?: Date;
  setDate?: (date: Date | null) => void;
  inline?: boolean;
  selectsStart?: boolean;
  selectsEnd?: boolean;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
};

const Picker = ({
  date,
  setDate,
  inline,
  selectsStart,
  selectsEnd,
  startDate,
  endDate,
  minDate,
  maxDate,
  className,
}: PickerProps) => {
  const interfaceLanguage = useAppSelector(interfaceLanguageSelector);
  const [locale, setLocale] = useState<string>('en');

  useEffect(() => {
    switch (interfaceLanguage?.code) {
      case 'pt':
        registerLocale('pt', pt);
        setLocale('pt');
        break;
      case 'es':
        registerLocale('es', es);
        setLocale('es');
        break;
      default:
        registerLocale('en', enUS);
        setLocale('en');
    }
  }, [interfaceLanguage]);

  return (
    <div
      className={classes(styles.datePicker, {
        [className || '']: !!className,
      })}
    >
      <DatePicker
        className={styles.datePickerInput}
        dateFormat='d MMM yyyy'
        inline={inline}
        locale={locale}
        selected={date}
        onChange={date => setDate?.(date)}
        showIcon={true}
        toggleCalendarOnIconClick={true}
        icon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
          >
            <path
              d='M13.1667 2.66699H3.83333C3.09695 2.66699 2.5 3.26395 2.5 4.00033V13.3337C2.5 14.07 3.09695 14.667 3.83333 14.667H13.1667C13.903 14.667 14.5 14.07 14.5 13.3337V4.00033C14.5 3.26395 13.903 2.66699 13.1667 2.66699Z'
              stroke='#145C99'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.168 1.33301V3.99967'
              stroke='#145C99'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5.83203 1.33301V3.99967'
              stroke='#145C99'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M2.5 6.66699H14.5'
              stroke='#145C99'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
};

export default Picker;
